(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('ExportadorFilterFieldCtrl', ExportadorFilterFieldCtrl);

  ExportadorFilterFieldCtrl.$inject = [];

  function ExportadorFilterFieldCtrl() {
    const vm = this;

    //////////////////////////////////////////
    // Controller data
    vm.schema = {}; // vem da diretiva
    vm.value = {}; // vem da diretiva

    vm.datePickerOptionsGeral = {
      showWeeks: false,
      formatDayTitle: 'dd/MM/yyyy'
    };
  }
}());
